// @ts-strict-ignore
import {
  allProjectsClient,
  CurrentProject,
  currentProjectClient,
  Project,
} from 'common/report/queries/app-api/project-metadata-client';
import {getProjectId, setOrgId} from 'common/report/util';
import {ApiResource, ApiSingleValueResource} from 'common/util/model-resource/api-resource';

import {FeatureRolloutName, FeatureRollouts} from '../util/feature-sampling';

export {CurrentProject, Project};

export class ProjectsResource extends ApiResource<Project> {
  apiClient = allProjectsClient;
}

export class CurrentProjectResource extends ApiSingleValueResource<CurrentProject> {
  apiClient = currentProjectClient;

  constructor({projectId = null, urlManager = null} = {}) {
    super();
    this.id = projectId ?? getProjectId(urlManager);
    // setup subscription to make project_id -> org_id mapping
    this.subscribe(() => {
      setOrgId({projectId: this.id, orgId: this.get().value.organizationId});
      if (this.get().value.organizationId) {
        mixpanel.track(`$experiment_started`, {
          'Experiment name': `Metric Menu`,
          'Variant name ': FeatureRollouts[FeatureRolloutName.NewMetricMenu].isEnabled(this.get().value)
            ? `New Metric Menu`
            : `Old Metric Menu`,
        });
        mixpanel.track(`$experiment_started`, {
          'Experiment name': `Experiments Everywhere`,
          'Variant name ': FeatureRollouts[FeatureRolloutName.ExperimentsEverywhere].isEnabled(this.get().value)
            ? `Test`
            : `Control`,
        });
      }
    });
  }
}
